import { Component, inject, Input, OnInit } from '@angular/core';
import { Company, CompanyEnum } from '../../models/company.model';
import { ApplicationFormComponent } from '../application-form/application-form.component';
import { PriceListsPopupComponent } from '../price-lists-popup/price-lists-popup.component';
import { TermsAndConditionsComponent } from '../terms-and-conditions/terms-and-conditions.component';
import { PublicHolidaysComponent } from '../public-holidays/public-holidays.component';
import { AyaProgramDatesComponent } from '../aya-program-dates/aya-program-dates.component';
import { AyaSessionBreaksComponent } from '../aya-session-breaks/aya-session-breaks.component';
import { AyaSupplementsComponent } from '../aya-supplements/aya-supplements.component';
import { ApplicationFormService } from '../../services/application-form.service';
import { AcademicYearSupplements, ProgramDates, SessionBreaks } from '../../models';

@Component({
  standalone: true,
  selector: 'lx-price-lists-portal-price-aya-list-links',
  templateUrl: './aya-price-list-links.component.html',
  styleUrls: ['./aya-price-list-links.component.scss', './print-aya-price-list-links.component.scss'],
  imports: [
    ApplicationFormComponent,
    PriceListsPopupComponent,
    TermsAndConditionsComponent,
    PublicHolidaysComponent,
    AyaProgramDatesComponent,
    AyaSessionBreaksComponent,
    AyaSupplementsComponent,
  ],
})
export class AyaPriceListLinksComponent implements OnInit {
  @Input() company: Company = CompanyEnum.KIL;
  @Input() countryCode: string | undefined;
  @Input() schoolLanguage: string | undefined;
  @Input() supplements: AcademicYearSupplements;
  @Input() programDates: ProgramDates | undefined;
  @Input() sessionBreaks: SessionBreaks | undefined;

  applicationForms = [];

  private readonly applicationFormService = inject(ApplicationFormService);

  ngOnInit(): void {
    this.applicationForms = this.applicationFormService.getAyaApplicationForm(this.schoolLanguage);
  }
}
